export default {
	"18838ed4a2bbcecf9f2fd03095c9ee99": "已閲讀並同意",
	"e69cd9cc1acea3c54a1a5636d5cfd594": "《用户服務協議》",
	"46a8e8392001c13c67f883e9e2d62285": "《自動續費協議》",
	"b72be4162301b6d49a3956896000d13a": "《用户購買協議》"
}
